export const GRID = {
  TWO_COL: {
    XS: {
      FULL_WIDTH: 12,
    },
    MD: {
      LEFT_COLUMN: { size: 7, offset: 0 },
      RIGHT_COLUMN: { size: 5, offset: 0 },
    },
    LG: {
      LEFT_COLUMN: { size: 6, offset: 1 },
      RIGHT_COLUMN: 5,
      LEFT_COLUMN_LARGE: 8,
      RIGHT_COLUMN_LARGE: 4,
      FULL_WIDTH: { size: 11, offset: 1 },
      FULL_WIDTH_NO_OFFSET: { size: 12, offset: 0 },
    },
    XL: {
      FULL_WIDTH: { size: 10, offset: 1 },
      FULL_WIDTH_NO_OFFSET: { size: 12, offset: 0 },
      RIGHT_COLUMN: 4,
    },
  },
};
